import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TypeVacationService {
  private apiUrl = `${environment.apiUrl}/typevacations`;

  constructor(private http: HttpClient) {}

  comboTypeVacation(): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl+"/combo");
  }
}
